<div id="upgradePlan" class="page-container shadow" style="min-height:188.38330078125px">
  <div class="page-content text-center">
    <section class="layer plans">
      <div class="row">
        <span class="pull-left" translate>Subscsription Plans</span>
        <div class="btn-group pull-right">
          <button type="button" class="btn btn-default" [ngClass]="{'active': paymentPeriod=='Monthly'}" (click)="paymentPeriod='Monthly'" translate>Monthly</button>
          <button type="button" class="btn btn-default" [ngClass]="{'active': paymentPeriod=='Yearly'}" (click)="paymentPeriod='Yearly'" translate>Yearly</button>
        </div>
      </div>
      <br><br>
      <p translate>Choose the plan that's right for you.</p>
      <br>
      <section>

        <section class="third lift plan-tier callout">
          <h6 translate>Most popular</h6>
          <h4 translate>Pro</h4>
          <h5><span class="plan-price">{{(paymentPeriod=='Monthly') ? thePlanInfo?.proMonthly : thePlanInfo?.proYearly}}  {{thePlanInfo?.priceCurrency}}</span><sub> /{{translate.instant(paymentPeriod=='Monthly' ? 'mo' : 'ye')}}</sub></h5>
          <!--p class="early-adopter-price" translate>Early adopter price</p-->
          <!--del translate>$40/mo</del--><br>
          <button class="btn btn-primary btn-xlg" type="button" (click)="getPaymentForm('PRO', paymentPeriod, paymentPeriod=='Monthly' ? thePlanInfo?.proMonthly : thePlanInfo?.proYearly)" data-toggle="modal" [attr.data-target]="modalId != '' ? '#' + modalId : null" translate>Select</button>
          <ul>
            <li>{{thePlanInfo?.proSignatures}} <span translate>monthly signatures</span></li>
            <li>{{thePlanInfo?.proStorage}} GB <span translate>storage space</span></li>
            <li translate>Single signer</li>
            <li><span translate>Multiple signers</span> (<span translate>max</span> {{thePlanInfo?.proSigners}})</li>
            <li translate>All documents must include signature of the owner</li>
            <li translate>Sign with Turkcell</li>
            <li translate>Sign with TurkTelekom mobile</li>
            <li translate>Sign with Vodafone mobile</li>
            <li translate>Sign with USB Token (Windows/Mac)</li>
            <li translate>Combining documents</li>
            <li>Box, Google Drive</li>
            <li translate>Image to PDF</li>
            <li translate>Secure storage</li>
            <li translate>Archiving</li>
            <li translate>Tags</li>
            <li translate>Audit Trail</li>
            <li translate>Document filtering</li>
            <li translate>Smart Filters</li>
            <li translate>Technical Support</li>
          </ul>
        </section>
        <section class="third lift plan-tier">
          <h4 translate>Enterprise</h4>
          <h5><span class="plan-price">{{(paymentPeriod=='Monthly') ? thePlanInfo?.enterpriseMonthly : thePlanInfo?.enterpriseYearly}} {{thePlanInfo?.priceCurrency}}</span><sub> /{{translate.instant(paymentPeriod=='Monthly' ? 'mo' : 'ye')}}</sub></h5>
          <!--p class="early-adopter-price" translate>Early adopter price</p-->
          <!--del translate>$200/mo</del--><br>
          <button class="btn btn-primary btn-xlg" type="button" (click)="getPaymentForm('ENTERPRISE', paymentPeriod, paymentPeriod=='Monthly' ? thePlanInfo?.enterpriseMonthly : thePlanInfo?.enterpriseYearly)" data-toggle="modal" [attr.data-target]="modalId != '' ? '#' + modalId : null"  translate>Select</button>
          <ul>
            <li translate>All features of Professional plan</li>
            <li>{{thePlanInfo?.enterpriseSignatures}} <span translate>monthly signatures</span></li>
            <li>{{thePlanInfo?.enterpriseStorage}} GB <span translate>storage space</span></li>
            <li><span translate>Multiple signers</span> (<span translate>max</span> {{thePlanInfo?.enterpriseSigners}})</li>
            <li translate>Create document for others (documents may not include the signature of the owner)</li>
            <li translate>Bulk document upload</li>
            <li translate>Bulk document download</li>
            <li translate>Bulk document deletion / archiving</li>
            <li class="no-border">&nbsp;</li>
            <li class="no-border">&nbsp;</li>
            <li class="no-border">&nbsp;</li>
            <li class="no-border">&nbsp;</li>
            <li class="no-border">&nbsp;</li>
            <li class="no-border">&nbsp;</li>
            <li class="no-border">&nbsp;</li>
            <li class="no-border">&nbsp;</li>
            <li class="no-border">&nbsp;</li>
            <li class="no-border">&nbsp;</li>
          </ul>
        </section>
        <div class="clearfix"></div>
      </section>
      <br><br>
      <p translate>Free plan starts after trial period ends. Free plan is restricted with using basic signature and signing only own documents.</p>
      <p translate>Have questions?</p>
      <p translate [innerHTML]="'CONTACT_US_UPGRADE' | translate"></p>
      <p translate>* Prices exclude VAT.</p>
    </section>

    <button id="openModal" class="btn" style="display: none" type="button" data-toggle="modal" data-target="#modal_upgrade">Open Modal</button>
    <!--<div align="center" id="iyzipay-checkout-form" class="popup"></div>-->
  </div>
</div>


<div *ngIf="paymentModalVisibility">
  <sd-payment [plan]="selectedPlan" [action]="paymentAction"></sd-payment>
</div>


<div id="modal_upgrade" class="modal fade"  data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h4 class="modal-title" translate>Change Plan Confirmation</h4>
      </div>
      <div class="modal-body">
        <h5 translate>New Plan</h5>
        <div class="panel panel-flat border-grey border-*-info my-panel">
          <div class="panel-body">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <p translate>Enterprise</p>
                  <br>
                  <p><strong>{{translate.instant(paymentPeriod)}}: {{currentPrice}} {{thePlanInfo?.priceCurrency}} /{{translate.instant(paymentPeriod =='Monthly' ? 'month' : 'year')}}</strong></p>
                </div>
              </div>
              <div class="col-sm-8">
                <div *ngIf="paymentPeriod =='Monthly'" class="form-group">
                  <p [innerHTML]="'BALANCE_REMAINING_MONTHLY_UPGRADE' | translate:{remainPrice:remainPrice,currency:thePlanInfo?.priceCurrency,upgradePrice:upgradePrice}"></p>
                </div>
                <div *ngIf="paymentPeriod =='Yearly'" class="form-group">
                  <p [innerHTML]="'BALANCE_REMAINING_YEARLY_UPGRADE' | translate:{remainPrice:remainPrice,currency:thePlanInfo?.priceCurrency,upgradePrice:upgradePrice}"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
        <ng-container *ngIf="paymentMethod == 'IYZICO'">
          <h5 translate>Credit Card</h5>
          <div class="panel panel-flat border-grey border-*-info my-panel">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-8">
                  <div class="form-group">
                    <p><strong translate>Your Registered Card:</strong></p>
                    <br>
                    <p>XXXX XXXX XXXX {{authorization?.userAccount?.cardLastNo}}</p>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="useAnotherCard()" data-toggle="modal" data-target="#modal_payment" translate>Use Different Card</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="paymentMethod == 'PAYPOINT'">
          <h5>{{translate.instant("Renew Subscription")}}</h5>
          <div class="panel panel-flat border-grey border-*-info my-panel">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-8">
                  <div class="form-group">
                    <p><strong>{{translate.instant("Plan Expiry Date:")}}</strong> {{authorization.userAccount.subscription.planExpiryDate | date:'dd/MM/yyyy'}}</p>
                    <p><strong>{{translate.instant("Current Plan:")}}</strong> {{translate.instant(authorization.userAccount.subscription.plan.name)}} / {{translate.instant(authorization.userAccount.subscription.period)}}</p>
                    <p><strong>{{translate.instant("Renew Price:")}}</strong> {{authorization.userAccount.subscription.period == "Monthly" ? authorization.userAccount.subscription.plan.priceMonthly : authorization.userAccount.subscription.plan.priceYearly}} {{authorization.userAccount.subscription.plan.priceCurrency}} </p>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="renewSubcriptionPaypoint()" data-toggle="modal" >{{translate.instant("Renew Subscription")}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="paymentMethod == 'STRIPE'">
          <h5>{{translate.instant("Subscription is managed by Stripe")}}</h5>
          <div class="panel panel-flat border-grey border-*-info my-panel">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <p translate>Your plan change will be processed through Stripe. Any proration will be handled automatically.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link" data-dismiss="modal" translate>Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="false" (click)="approveNewPlan()" data-dismiss="modal" translate>Approve New Plan</button>
      </div>
    </div>
  </div>
</div>

<div id="modal_payment_adyen" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="modal-title" translate>Payment</h5>
      </div>

      <form #form="ngForm" novalidate>
        <div class="modal-body">
          <div class="row">

            <div class="col-sm-12">
              <div class="form-group">
                <div class="btn-group">
                  <button type="button" class="btn btn-default" [ngClass]="{'active': paymentGroup=='Company'}" (click)="paymentGroup='Company'" translate>Company</button>
                  <button type="button" class="btn btn-default" [ngClass]="{'active': paymentGroup=='Individual'}" (click)="paymentGroup='Individual'" translate>Invidual</button>
                </div>
              </div>

              <div *ngIf="paymentGroup=='Company'">
                <div class="form-group">
                  <input  class="form-control" [ngClass]="{'error': !title.valid && title.touched }" type="text" name="title" [placeholder]="translate.instant('Title')" [(ngModel)]="thePayment.company.title" #title="ngModel" required pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ ,.'-]+)$">
                </div>
              </div>

              <div *ngIf="paymentGroup=='Individual'">
                <div class="form-group">
                  <input class="form-control" [ngClass]="{'error': !name.valid && name.touched}" type="text" name="name" [placeholder]="translate.instant('Name')" [(ngModel)]="thePayment.individual.name" #name="ngModel" required pattern="^(?:(?:^| )[a-zA-ZsçÇöÖşŞıİğĞüÜ ,.'-]+ *){2,}$">
                </div>
              </div>

              <div class="row">
               <div *ngIf="paymentGroup=='Company'" class="col-sm-6">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!taxOffice.valid && taxOffice.touched}" type="text" name="taxOffice" [placeholder]="translate.instant('Tax Office')" [(ngModel)]="thePayment.company.taxOffice" #taxOffice="ngModel" required pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
                  </div>
                </div>

                <div *ngIf="paymentGroup=='Company'" class="col-sm-6">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!taxNo.valid && taxNo.touched}" type="text" name="taxNo" [placeholder]="translate.instant('Tax No')" [(ngModel)]="thePayment.company.taxNo" #taxNo="ngModel" required minlength="10" maxlength="11" pattern="[0-9]+">
                  </div>
                </div>
              </div>

              <div *ngIf="paymentGroup=='Individual'">
                <div class="form-group">
                  <input class="form-control" [ngClass]="{'error':!citizenId.valid && citizenId.touched}" type="text" id="citizenId" name="citizenId" [placeholder]="translate.instant('Citizen ID')" [(ngModel)]="thePayment.individual.citizenId" #citizenId="ngModel" required minlength="11" maxlength="11" pattern="[0-9]+">
                </div>
              </div>

              <div class="form-group">
                <textarea class="form-control" [ngClass]="{'error':!address.valid && address.touched}" name="address" [placeholder]="translate.instant('Address')" [(ngModel)]="thePayment.address" #address="ngModel" rows="2  " cols="50" required minlength="5" maxlength="255" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ0-9 '-.,:/]*)$"></textarea>
              </div>

              <div class="row">
                <div class="col-sm-5">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!city.valid && city.touched}" type="text" name="city" [placeholder]="translate.instant('City')" [(ngModel)]="thePayment.city" #city="ngModel" required maxlength="50" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!province.valid && province.touched}" type="text" name="province" [placeholder]="translate.instant('Province')" [(ngModel)]="thePayment.province" #province="ngModel" required maxlength="50" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .,]*)$">
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!zipCode.valid && zipCode.touched}" type="text" name="zipCode" [placeholder]="translate.instant('Zip Code')" [(ngModel)]="thePayment.zipCode" #zipCode="ngModel" required minlength="3" maxlength="10" pattern="^(\d{5}([\-]\d{4})?)?([0-9]{3,4})?([0-9]{5}[\-]?[0-9]{3})?([A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9])?([1-9][0-9]{3}\s?[a-zA-Z]{2})?(\d{3}-\d{4})?((L\s*(-|—|–))\s*?[\d]{4})?([0-9]{2}\-[0-9]{3})?(((0[1-9]|5[0-2])|[1-4][0-9])[0-9]{3})?(\d{3}\s?\d{2})?([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})?$">
                  </div>
                </div>
              </div>
              <div class="row col-sm-8">
                <div class="input-group">
                  <input type="text" class="form-control" [ngClass]="{'error':!discountCoupon.valid && discountCoupon.touched}" name="discountCoupon" [placeholder]="translate.instant('Discount Coupon')" [(ngModel)]="thePayment.discountCoupon" #discountCoupon="ngModel" min="1" pattern="^([0-9a-zA-ZçÇöÖşŞıİğĞüÜ]*)$">
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-outline-secondary" [disabled]="!discountCoupon.valid || thePayment.discountCoupon.length==0" (click)="checkCoupon(discountCoupon.value, discountCoupon.valid)" translate>Apply</button>
                  </span>
                </div>
              </div>
              <div class="m-10">
                <div *ngIf="thePayment.discountCoupon == '' || thePayment.discountCoupon == null" class="row col-sm-4 center-block">
                  {{translate.instant("No coupon entered.")}}
                </div>
                <div *ngIf="isCouponValid == false" class="row col-sm-4 center-block" style="color: red;">
                  {{translate.instant("Invalid coupon.")}}
                </div>
                <div *ngIf="isCouponValid == true" class="row col-sm-4 center-block" style="color: green;">
                  {{translate.instant("Coupon is valid. Discount: ")}}
                  <strong>
                    {{discountAmount + "%"}}
                  </strong>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div id="adyen-container">
            <div id="dropin-container"></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div id="modal_payment_paypoint" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="modal-title" translate>Payment</h5>
      </div>

      <form #form="ngForm" novalidate>
        <div class="modal-body">
          <div class="row">

            <div class="col-sm-12">
              <div class="form-group">
                <div class="btn-group">
                  <button type="button" class="btn btn-default" [ngClass]="{'active': paymentGroup=='Company'}" (click)="paymentGroup='Company'" translate>Company</button>
                  <button type="button" class="btn btn-default" [ngClass]="{'active': paymentGroup=='Individual'}" (click)="paymentGroup='Individual'" translate>Invidual</button>
                </div>
              </div>

              <div *ngIf="paymentGroup=='Company'">
                <div class="form-group">
                  <input  class="form-control" [ngClass]="{'error': !title.valid && title.touched }" type="text" name="title" [placeholder]="translate.instant('Title')" [(ngModel)]="thePayment.company.title" #title="ngModel" required pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ ,.'-]+)$">
                </div>
              </div>

              <div *ngIf="paymentGroup=='Individual'">
                <div class="form-group">
                  <input class="form-control" [ngClass]="{'error': !name.valid && name.touched}" type="text" name="name" [placeholder]="translate.instant('Name')" [(ngModel)]="thePayment.individual.name" #name="ngModel" required pattern="^(?:(?:^| )[a-zA-ZsçÇöÖşŞıİğĞüÜ ,.'-]+ *){2,}$">
                </div>
              </div>

              <div class="row">
               <div *ngIf="paymentGroup=='Company'" class="col-sm-6">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!taxOffice.valid && taxOffice.touched}" type="text" name="taxOffice" [placeholder]="translate.instant('Tax Office')" [(ngModel)]="thePayment.company.taxOffice" #taxOffice="ngModel" required pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
                  </div>
                </div>

                <div *ngIf="paymentGroup=='Company'" class="col-sm-6">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!taxNo.valid && taxNo.touched}" type="text" name="taxNo" [placeholder]="translate.instant('Tax No')" [(ngModel)]="thePayment.company.taxNo" #taxNo="ngModel" required minlength="10" maxlength="11" pattern="[0-9]+">
                  </div>
                </div>
              </div>

              <div *ngIf="paymentGroup=='Individual'">
                <div class="form-group">
                  <input class="form-control" [ngClass]="{'error':!citizenId.valid && citizenId.touched}" type="text" id="citizenId" name="citizenId" [placeholder]="translate.instant('Citizen ID')" [(ngModel)]="thePayment.individual.citizenId" #citizenId="ngModel" required minlength="11" maxlength="11" pattern="[0-9]+">
                </div>
              </div>

              <div class="form-group">
                <textarea class="form-control" [ngClass]="{'error':!address.valid && address.touched}" name="address" [placeholder]="translate.instant('Address')" [(ngModel)]="thePayment.address" #address="ngModel" rows="2  " cols="50" required minlength="5" maxlength="255" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ0-9 '-.,:/]*)$"></textarea>
              </div>

              <div class="row">
                <div class="col-sm-5">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!city.valid && city.touched}" type="text" name="city" [placeholder]="translate.instant('City')" [(ngModel)]="thePayment.city" #city="ngModel" required maxlength="50" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!province.valid && province.touched}" type="text" name="province" [placeholder]="translate.instant('Province')" [(ngModel)]="thePayment.province" #province="ngModel" required maxlength="50" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .,]*)$">
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!zipCode.valid && zipCode.touched}" type="text" name="zipCode" [placeholder]="translate.instant('Zip Code')" [(ngModel)]="thePayment.zipCode" #zipCode="ngModel" required minlength="3" maxlength="10" pattern="^(\d{5}([\-]\d{4})?)?([0-9]{3,4})?([0-9]{5}[\-]?[0-9]{3})?([A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9])?([1-9][0-9]{3}\s?[a-zA-Z]{2})?(\d{3}-\d{4})?((L\s*(-|—|–))\s*?[\d]{4})?([0-9]{2}\-[0-9]{3})?(((0[1-9]|5[0-2])|[1-4][0-9])[0-9]{3})?(\d{3}\s?\d{2})?([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})?$">
                  </div>
                </div>
              </div>

              <div class="row col-sm-8">
                <div class="input-group">
                  <input type="text" class="form-control" [ngClass]="{'error':!discountCoupon.valid && discountCoupon.touched}" name="discountCoupon" [placeholder]="translate.instant('Discount Coupon')" [(ngModel)]="thePayment.discountCoupon" #discountCoupon="ngModel" min="1" pattern="^([0-9a-zA-ZçÇöÖşŞıİğĞüÜ]*)$">
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-outline-secondary" [disabled]="!discountCoupon.valid || thePayment.discountCoupon.length==0" (click)="checkCoupon(discountCoupon.value, discountCoupon.valid)" translate>Apply</button>
                  </span>
                </div>
              </div>
              <div class="m-10">
                <div *ngIf="thePayment.discountCoupon == '' || thePayment.discountCoupon == null" class="row col-sm-4 center-block">
                  {{translate.instant("No coupon entered.")}}
                </div>
                <div *ngIf="isCouponValid == false" class="row col-sm-4 center-block" style="color: red;">
                  {{translate.instant("Invalid coupon.")}}
                </div>
                <div *ngIf="isCouponValid == true" class="row col-sm-4 center-block" style="color: green;">
                  {{translate.instant("Coupon is valid. Discount: ")}}
                  <strong>
                    {{discountAmount + "%"}}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer text-center">
          <button type="button" class="btn btn-default active btn-size" (click)="paypointRegisterTransaction()">Ödeme {{upgradePrice + "/" + (this.selectedPlan == null ? "" : this.selectedPlan.period)}}</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div id="modal_after_payment_adyen" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content" align="center">
      <div class="modal-header">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h3 class="modal-title" translate>Payment Status</h3>
      </div>
      <div class="modal-body">
        <div style="margin-bottom: 20px;">
          <i *ngIf="paymentStatusAdyen != 'Authorised'" class="icon-cross" style="font-size: 64px;color: red;"></i>
        </div>
        <h4>
          {{paymentStatusAdyen == null ? "" : translate.instant(paymentStatusAdyen)}}
        </h4>
        <h5>
          {{paymentRefusalReasonAdyen == null ? "" : translate.instant(paymentRefusalReasonAdyen)}}
        </h5>
      </div>
    </div>
  </div>
</div>

<div id="modal_payment_stripe" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button class="close" type="button" data-dismiss="modal">&times;</button>
        <h5 class="modal-title" translate>Payment</h5>
      </div>

      <form #stripeForm="ngForm" novalidate>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <div class="btn-group">
                  <button type="button" class="btn btn-default" [ngClass]="{'active': paymentGroup=='Company'}" (click)="paymentGroup='Company'" translate>Company</button>
                  <button type="button" class="btn btn-default" [ngClass]="{'active': paymentGroup=='Individual'}" (click)="paymentGroup='Individual'" translate>Individual</button>
                </div>
              </div>

              <div *ngIf="paymentGroup=='Company'">
                <div class="form-group">
                  <input class="form-control" [ngClass]="{'error': !stripeTitle.valid && stripeTitle.touched}" type="text" name="stripeTitle" [placeholder]="translate.instant('Title')" [(ngModel)]="thePayment.company.title" #stripeTitle="ngModel" required pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ ,.'-]+)$">
                </div>
              </div>

              <div *ngIf="paymentGroup=='Individual'">
                <div class="form-group">
                  <input class="form-control" [ngClass]="{'error': !stripeName.valid && stripeName.touched}" type="text" name="stripeName" [placeholder]="translate.instant('Name')" [(ngModel)]="thePayment.individual.name" #stripeName="ngModel" required pattern="^(?:(?:^| )[a-zA-ZsçÇöÖşŞıİğĞüÜ ,.'-]+ *){2,}$">
                </div>
              </div>

              <div class="row">
                <div *ngIf="paymentGroup=='Company'" class="col-sm-6">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!stripeTaxOffice.valid && stripeTaxOffice.touched}" type="text" name="stripeTaxOffice" [placeholder]="translate.instant('Tax Office')" [(ngModel)]="thePayment.company.taxOffice" #stripeTaxOffice="ngModel" required pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
                  </div>
                </div>
                <div *ngIf="paymentGroup=='Company'" class="col-sm-6">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!stripeTaxNo.valid && stripeTaxNo.touched}" type="text" name="stripeTaxNo" [placeholder]="translate.instant('Tax No')" [(ngModel)]="thePayment.company.taxNo" #stripeTaxNo="ngModel" required minlength="10" maxlength="11" pattern="[0-9]+">
                  </div>
                </div>
              </div>

              <div *ngIf="paymentGroup=='Individual'">
                <div class="form-group">
                  <input class="form-control" [ngClass]="{'error':!stripeCitizenId.valid && stripeCitizenId.touched}" type="text" name="stripeCitizenId" [placeholder]="translate.instant('Citizen ID')" [(ngModel)]="thePayment.individual.citizenId" #stripeCitizenId="ngModel" required minlength="11" maxlength="11" pattern="[0-9]+">
                </div>
              </div>

              <div class="form-group">
                <textarea class="form-control" [ngClass]="{'error':!stripeAddress.valid && stripeAddress.touched}" name="stripeAddress" [placeholder]="translate.instant('Address')" [(ngModel)]="thePayment.address" #stripeAddress="ngModel" rows="2" cols="50" required minlength="5" maxlength="255" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ0-9 '-.,:/]*)$"></textarea>
              </div>

              <div class="row">
                <div class="col-sm-5">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!stripeCity.valid && stripeCity.touched}" type="text" name="stripeCity" [placeholder]="translate.instant('City')" [(ngModel)]="thePayment.city" #stripeCity="ngModel" required maxlength="50" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!stripeProvince.valid && stripeProvince.touched}" type="text" name="stripeProvince" [placeholder]="translate.instant('Province')" [(ngModel)]="thePayment.province" #stripeProvince="ngModel" required maxlength="50" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .,]*)$">
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!stripeZipCode.valid && stripeZipCode.touched}" type="text" name="stripeZipCode" [placeholder]="translate.instant('Zip Code')" [(ngModel)]="thePayment.zipCode" #stripeZipCode="ngModel" required minlength="3" maxlength="10">
                  </div>
                </div>
              </div>

              <div class="row col-sm-8">
                <div class="input-group">
                  <input type="text" class="form-control" [ngClass]="{'error':!stripeDiscountCoupon.valid && stripeDiscountCoupon.touched}" name="stripeDiscountCoupon" [placeholder]="translate.instant('Discount Coupon')" [(ngModel)]="thePayment.discountCoupon" #stripeDiscountCoupon="ngModel" min="1" pattern="^([0-9a-zA-ZçÇöÖşŞıİğĞüÜ]*)$">
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-outline-secondary" [disabled]="!stripeDiscountCoupon.valid || thePayment.discountCoupon.length==0" (click)="checkCoupon(stripeDiscountCoupon.value, stripeDiscountCoupon.valid)" translate>Apply</button>
                  </span>
                </div>
              </div>
              <div class="m-10">
                <div *ngIf="thePayment.discountCoupon == '' || thePayment.discountCoupon == null" class="row col-sm-4 center-block">
                  {{translate.instant("No coupon entered.")}}
                </div>
                <div *ngIf="isCouponValid == false" class="row col-sm-4 center-block" style="color: red;">
                  {{translate.instant("Invalid coupon.")}}
                </div>
                <div *ngIf="isCouponValid == true" class="row col-sm-4 center-block" style="color: green;">
                  {{translate.instant("Coupon is valid. Discount: ")}}
                  <strong>{{discountAmount + "%"}}</strong>
                </div>
              </div>
            </div>
          </div>

          <hr>

          <div id="stripe-billing-submit" class="text-center" *ngIf="!stripeClientSecret">
            <button type="button" class="btn btn-primary btn-lg" [disabled]="stripeLoading" (click)="stripeSubmitPayment()" translate>Proceed to Payment</button>
          </div>

          <div id="stripe-payment-container" *ngIf="stripeClientSecret">
            <h5 translate>Card Details</h5>
            <div id="stripe-payment-element"></div>
            <div id="stripe-confirm-section" class="text-center" style="margin-top: 20px;">
              <button type="button" class="btn btn-primary btn-lg" [disabled]="stripeLoading" (click)="stripeConfirmPayment()" translate>Pay Now</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<form id="paypointForm" method="POST" [action]="paypointResponse.RedirectUri">
  <input type="hidden" id="MerchantCode" name="MerchantCode" [value]="paypointResponse.MerchantCode">
  <input type="hidden" id="MerchantUser" name="MerchantUser" [value]="paypointResponse.MerchantUser">
  <input type="hidden" id="MerchantTrnId" name="MerchantTrnId" [value]="paypointResponse.MerchantTrnId">
  <input type="hidden" id="TrnKey" name="TrnKey" [value]="paypointResponse.TrnKey">
  <input type="hidden" id="Amount" name="Amount" [value]="paypointResponse.Amount">
  <input type="hidden" id="Currency" name="Currency" [value]="paypointResponse.Currency">
  <input type="hidden" id="Description" name="Description" [value]="paypointResponse.Description">
  <input type="hidden" id="Lang" name="Lang" [value]="paypointResponse.Lang">
</form>
